import { createFileRoute, notFound } from '@tanstack/react-router';

type Params = {
  filter: 'inbox' | 'drafts' | 'archived' | 'blocked' | 'contacts';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/$filter')({
  staticData: { team: 'fe-messaging' },
  params: {
    parse: (params): Params => {
      const validFilters = ['inbox', 'drafts', 'archived', 'blocked', 'contacts'];
      if (!validFilters.includes(params.filter)) {
        throw notFound();
      }
      return params as Params;
    },
  },
});
